export const DEFAULT_PLACEMENT = 1;

export const ANYFEED_PAGINATION_LIMIT = 20;

export const PLACEHOLDER_SECTION_ICON = '';

export const DATA_TYPES = {
  COURSE: 'course'
};

export const SUB_DATA_TYPES = {
  WITHOUT_TEXT: 'without_text'
};

export const CARD_TYPES = {
  VERTICAL_LIST_GRID: 'vertical_list_grid',
  HERO: 'hero',
  VERTICAL_LIST: 'vertical_list', // list nx1
  HORIZONTAL_LIST: 'horizontal_list', // carousel 1xn
  GRID: 'grid', // 2x2
  VARIABLE_GRID: 'variable_grid' // nxn grid with items having variable height & width
};
export const DECORATED_TITLE_TYPE = 'decorated';

export const DOWNLOAD_APP_TITLE = 'Continue watching on our android app';

export const DOWNLOAD_APP_DESCRIPTION = 'Learn on the go';
